
require('dotenv').config()
export const s3Conf = { 
    root : process.env.REACT_APP_AWS_S3_ROOT
};